module.exports = __webpack_public_path__ + "static/media/not-use@2x.8fe853f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/not-use@2x.png
// module id = 888
// module chunks = 0